
export default {
  props: {
    generating: {type: Boolean, default: false},
    canPush: {type: Boolean, default: false},
  },
  emits: ['push', 'stop']
}
